/**
 * Input row component
 *
 * Should include Column component to adjust Rows negative margin
 *
 * Optional props:
 * noWrap : boolean - add no-wrap value to flex-wrap attribute
 * left : boolean - Add psuedo after element to not center last row columns
 *
 * Examples of component:
 * <Row>
 *   <Column>...</Column>
 * </Row>
 *
 * <Row left>
 *   <Column>...</Column>
 * </Row>
 *
 */

import styled from 'styled-components';

const Row = styled.div`
	display: flex;
	flex-wrap: ${props => (props.noWrap ? 'no-wrap' : 'wrap')};
	justify-content: ${props => props.justify || 'space-between'};
	margin-left: -10px;
	margin-right: -10px;

	${props =>
		props.left &&
		`
		&:after {
			content: '';
			flex: auto;
		}
`};
`;

export default Row;



// WEBPACK FOOTER //
// ./src/components/Common/Row/Row.js